import { useEffect, useRef } from "react";
/**
 * This hook helps set/clear timeout for an event.
 */
export var useDelay = function (event, timeoutMs) {
    if (timeoutMs === void 0) { timeoutMs = 1500; }
    var timeout = useRef();
    var clearDelay = function (executeEvent) {
        if (executeEvent === void 0) { executeEvent = false; }
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = undefined;
        }
        if (executeEvent) {
            event();
        }
    };
    var setDelay = function () {
        clearDelay();
        timeout.current = window.setTimeout(event, timeoutMs);
    };
    useEffect(function () {
        return function () {
            clearDelay();
        };
    }, []);
    return [setDelay, clearDelay];
};
